import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';

import api from 'src/axios';

export const useSynchronizeProductWithScopePurchase = (
  options?: Omit<UseMutationOptions<void, Error>, 'mutationFn'>,
): UseMutationResult<void, Error, void> => {
  return useMutation({
    mutationFn: async () => {
      const { data } = await api.post(`/products/scope-purchase/synchronize`);
      return data;
    },
    ...options,
  });
};
